import { createSlice } from "@reduxjs/toolkit";
import { ApprovedStatus } from "core/http/service/internalDocument/resTypes";
import { set } from "lodash";

interface FormInterface {
  requestId?: string;
  requestCode?: string;
  departmentLevel1Code: string;
  departmentLevel2Code: string;
  departmentLevel3Code?: string;
  departmentCode: string;
  rcmPositionCode: string;
  rcmPositionLevel: string;
  totalHuman: string;
  boundaryQuantity: string;
  quantityRequest: string;
  recruitmentReason: string;
  workingAddress: string;
  mngApproveCode: string;
  jobDescription: string;
  degreeCode: string;
  specializedCode: any[];
  practiceCertificateCode: any[];
  languageLevelCode: any[];
  experienceCode: string;
  genderCode: string;
  minAge: string;
  maxAge: string;
  otherIdea: string;
  files_files: any[];
  files: {
    originalFilename: string;
    path: string;
  }[];
  mngApproveStatus?: string;
  mngApproveDate?: string;
  mngNote?: string;
  hrmApproveCode?: string;
  hrmApproveStatus?: string;
  hrmApproveDate?: string;
  hrmNote?: string;
  quantityApprove?: string;
  finalStatus?: string;
  finalStatusName?: string;
  relatePersonName?: string;
  genderName?: string;
  experienceName?: string;
  rcmPositionLevelName?: string;
  recruitmentReasonName?: string;
  positionName?: string;
  degreeName?: string;
  specializedCodes?: any[];
  languageLevelCodes?: any[];
  practiceCertificateCodes?: any[];
  departmentLevel2Name?: string;
  departmentLevel3Name?: string;
  workingAddressName?: string;
  canApprove?: number;
  canDelete?: number;
  canUpdate?: number;
  canRefuseable?: number;
  specializedNames?: string;
  languageLevelNames?: string;
  practiceCertificateNames?: string;
}

interface IStep {
  label: string;
  updateAt?: string;
  updateBy?: string;
  status?: ApprovedStatus;
}

interface InitialState {
  data: FormInterface;
  steps: IStep[];
}

const initialState: InitialState = {
  data: {
    departmentLevel1Code: "",
    departmentLevel2Code: "",
    departmentLevel3Code: "",
    departmentCode: "",
    rcmPositionCode: "",
    rcmPositionLevel: "",
    totalHuman: "",
    boundaryQuantity: "",
    quantityRequest: "",
    recruitmentReason: "",
    workingAddress: "",
    mngApproveCode: "",
    jobDescription: "",
    degreeCode: "",
    specializedCode: [],
    practiceCertificateCode: [],
    languageLevelCode: [],
    experienceCode: "",
    genderCode: "",
    minAge: "",
    maxAge: "",
    otherIdea: "",
    files: [],
    files_files: [],
  },
  steps: [
    {
      label: "Người tạo",
    },
    {
      label: "CBQL phê duyệt",
    },
    {
      label: "HR phê duyệt",
    },
  ],
};

const formRecruitmentSlice = createSlice({
  name: "formRecruitment",
  initialState,
  reducers: {
    updateFileRecruitment: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.data, keys[i], action.payload[keys[i]]);
      }
    },
    formRecruitmentUpdate: (state, action) => {
      Object.assign(state.data, action.payload);
    },

    formRecruitmentReset: () => {
      return { ...initialState };
    },
    updateSteps: (state, action) => {
      state.steps = action.payload;
    },
  },
});

export const {
  formRecruitmentUpdate,
  updateFileRecruitment,
  formRecruitmentReset,
  updateSteps,
} = formRecruitmentSlice.actions;

export default formRecruitmentSlice.reducer;
